import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import toAssetAtom from './to-asset.js';
const isExactOutSupportedAtom = atom(async (get, { exodus }) => {
    const fromAsset = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    try {
        return await exodus.exchange.isExactOutSupported({
            fromTicker: fromAsset.ticker,
            toTicker: toAsset.ticker,
        });
    }
    catch {
        return false;
    }
});
export default isExactOutSupportedAtom;
